import {removeOldMessages, resetState} from '@Redux/chatSlice';
    import {store} from '@Redux/store';
    import {persistor} from '@Redux/store';

    /**
     * Function to check if localStorage is nearing its storage limit and handle overflow by deleting older messages.
     * This function attempts to add a test item to localStorage to check for storage overflow.
     * If storage is full, it dispatches an action to remove old messages from the Redux store.
     *
     * @param {Function} dispatch - Redux dispatch function to send actions to the store.
     */
    export const checkAndHandleStorageOverflow = (dispatch, userId) => {
      try {
        localStorage.setItem('storage_test', 'test');
        localStorage.removeItem('storage_test');
      } catch (e) {
        if (e.name === 'QuotaExceededError') {
          console.warn('Storage is full, deleting older messages...');
          dispatch(removeOldMessages({ userId }));
        }
      }

      // Check time-based condition when handling storage overflow
      checkOldMessages(userId);
    };

    // Function to check and handle old messages
    export const checkOldMessages = async (userId) => {
      // Wait until the persistor is bootstrapped
      const state = persistor.getState();
      if (!state.bootstrapped) {
        // Simple loop to keep checking until the persistor is bootstrapped
        while (!persistor.getState().bootstrapped) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }
      const storeState = store.getState();
      const messages = storeState.chat.userChats[userId];
      if (messages && messages.length > 1) {
        const lastMessageTime = new Date(messages[messages.length - 1].timestamp);
        const now = new Date();

        if ((now - lastMessageTime) > 8 * 60 * 60 * 1000) { // 8 hours
          console.log('8 hours passed since last message, clearing chat...');
          store.dispatch(resetState({ userId }));
        }
      }
    };

    // Function to check all users' chats for old messages at app startup
    export const checkAllUsersOldMessages = async () => {
      // Wait until the persistor is bootstrapped
      const state = persistor.getState();
      if (!state.bootstrapped) {
        while (!persistor.getState().bootstrapped) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }

      const storeState = store.getState();
      const userChats = storeState.chat.userChats;

      if (userChats) {
        Object.keys(userChats).forEach(userId => {
          checkOldMessages(userId);
        });
      }
    };